import type Player from 'video.js/dist/types/player';

const FULLSCREEN_EXIT_SVG = `<svg viewBox="0 0 512 512"><use href="#vjs-icon-fullscreen-exit"></use></svg>`;
const FULLSCREEN_ENTER_SVG = `<svg viewBox="0 0 512 512"><use href="#vjs-icon-fullscreen-enter"></use></svg>`;

interface DocumentWithFullscreen extends Document {
  webkitFullscreenElement?: Element;
  mozFullScreenElement?: Element;
  msFullscreenElement?: Element;
}

const isInFullScreen = () => {
  const doc = document as DocumentWithFullscreen;

  return !!(
    doc.fullscreenElement ||
    doc.mozFullScreenElement ||
    doc.webkitFullscreenElement ||
    doc.msFullscreenElement
  );
};

const toggleFullscreen = () => {
  const documentElement = document.documentElement;
  if (!isInFullScreen()) {
    if (documentElement.requestFullscreen) {
      documentElement.requestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
};

export const fullScreenChangeListener = () => {
  const iconWrapper = document.querySelector(
    '.custom-fullscreen-btn .vjs-svg-icon'
  );

  const svg = isInFullScreen() ? FULLSCREEN_EXIT_SVG : FULLSCREEN_ENTER_SVG;

  if (iconWrapper) iconWrapper.innerHTML = svg;
};

export const setFullScreenButton = (player: Player | null) => {
  if (player) {
    // @ts-ignore
    const fullScreenBtn = player.controlBar.addChild('button');
    fullScreenBtn.addClass('custom-fullscreen-btn');
    const fullScreenBtnElement = fullScreenBtn.el();
    const svg = isInFullScreen() ? FULLSCREEN_EXIT_SVG : FULLSCREEN_ENTER_SVG;
    const fullScreenIcon = `<span class="vjs-icon-placeholder vjs-svg-icon" aria-hidden="true">${svg}</span>`;

    fullScreenBtnElement.innerHTML = fullScreenIcon;

    if (document.fullscreenEnabled === true) {
      fullScreenBtnElement.addEventListener('click', toggleFullscreen);
    } else {
      fullScreenBtnElement.setAttribute('disabled', 'disabled');
    }
  }
};
